import { roundMoney } from './money.js';
export function buildPaymentQrPayload(params) {
    const sumKopecks = roundMoney(params.sum).times(100).toFixed(0);
    const fields = [
        ['Name', params.payeeName],
        ['PersonalAcc', params.accountNumber],
        ['BankName', params.bankName],
        ['BIC', params.bik],
        ['CorrespAcc', params.corrAccount],
        ['PayeeINN', params.inn],
    ];
    if (params.kpp)
        fields.push(['KPP', params.kpp]);
    fields.push(['Sum', sumKopecks]);
    fields.push(['Purpose', params.purpose]);
    return ['ST00012', ...fields.map(([key, value]) => `${key}=${value}`)].join('|');
}
//# sourceMappingURL=payment-qr.js.map